import React, { useState, useEffect } from "react";
import BackBtn from "../../btncomponent/BackBtn";
import { isAuthenticated } from "../../auth";
import City from "./City";

const AddCity = () => {
  const [name, setName] = useState("");
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    setError("");
    setSuccess(false);
    setName(e.target.value);
  };

  const clickSubmit = (e) => {
    e.preventDefault();
    const id = isAuthenticated().user._id;
    const token = isAuthenticated().token;
    fetch(`${process.env.REACT_APP_API_URL}/create/new/city/${id}`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ name }),
    })
      .then((res) => {
        return res.json();
      })
      .catch((err) => {
        console.log(err);
      })
      .then((data) => {
        if (data.error) {
          setError(true);
          setSuccess(false);
          setName("");
        } else {
          setError("");
          setSuccess(true);
          setName("");
        }
      });
  };

  const showSuccess = () => {
    if (success) {
      return <h3 className="text-success"> City created successfully</h3>;
    }
  };

  const showError = () => {
    if (error) {
      return <h3 className="text-danger ">City Name should be unique</h3>;
    }
  };

  return (
    <div className="container mt-3">
      <h2>Add City</h2>
      <BackBtn location="/admin/dashboard" />
      {showSuccess()}
      {showError()}
      <div className="row">
        <div className="col-sm-6">
          <form onSubmit={clickSubmit}>
            <div className="form-group">
              <label className="text-muted">Name </label>
              <input
                type="text"
                onChange={handleChange}
                value={name}
                className="form-control"
                autoFocus
                required
              />

              <button
                type="submit"
                className="btn float-right mt-3"
                style={{ backgroundColor: "#FCCE01", borderRadius: "0" }}
              >
                Create City
              </button>
            </div>
          </form>
        </div>
        <div className="col-sm-1"></div>
        <div className="col-sm-5 mt-3">
          <City />
        </div>
      </div>
    </div>
  );
};

export default AddCity;
